import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import config from "config.json";
import { authHeader, authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { HistorialSolicitudes } from "./TypesHistorialSolicitudes";

export async function ObtenerAniosHistorial(){
    const URL = config.SERVER_URL + "Aprobacion/HistorialAprobaciones/AniosDisponibles"
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: number[] = respuesta.data;
        resultado = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

export async function ObtenerHistorial(anio:number){
    const URL = config.SERVER_URL + "Aprobacion/HistorialAprobaciones/"+ anio
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: HistorialSolicitudes[] = respuesta.data;
        resultado = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

